import { Tab, Tabs } from '@mui/material'
import { Link } from 'react-router-dom'
import { useLayout } from 'hooks/useLayout'
import { featureAccessStore } from 'stores/featureAccessStore'

export const LicensedEstablishmentDetailsTabs = ({
  licensedEstablishmentId,
  currentTab,
}: {
  licensedEstablishmentId: number
  currentTab: string
}) => {
  const { isMobile } = useLayout()
  const noRewardsFeatureAllowed = featureAccessStore.getState().noRewards

  return (
    <Tabs value={currentTab} variant={isMobile ? 'fullWidth' : 'standard'}>
      <Tab
        label="Overview"
        value={`/ClientManagement/LicensedEstablishments/${licensedEstablishmentId}`}
        to={`/ClientManagement/LicensedEstablishments/${licensedEstablishmentId}`}
        component={Link}
      />
      {!noRewardsFeatureAllowed && (
        <Tab
          label="Reward Programs"
          value={`/ClientManagement/LicensedEstablishments/${licensedEstablishmentId}/RewardsProgram`}
          to={`/ClientManagement/LicensedEstablishments/${licensedEstablishmentId}/RewardsProgram`}
          component={Link}
        />
      )}
      <Tab
        label="Specials & Events"
        value={`/ClientManagement/LicensedEstablishments/${licensedEstablishmentId}/LicensedEstablishmentDetailsSpecialsEvents`}
        to={`/ClientManagement/LicensedEstablishments/${licensedEstablishmentId}/LicensedEstablishmentDetailsSpecialsEvents`}
        component={Link}
      />
    </Tabs>
  )
}
